import * as React from 'react';

import {Box, CircularProgress, IconButton, Link, Typography} from "@mui/material";
import * as turf from "@turf/turf";
import {PieChart} from "react-minimal-pie-chart";
import Map, {Layer, Marker, Popup, Source} from 'react-map-gl';

import 'mapbox-gl/dist/mapbox-gl.css';
// eslint-disable-next-line
import mapboxgl from '!mapbox-gl';
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {correctId, correctName, formatPercentage} from "../../../Utils";
import CircleIcon from "@mui/icons-material/Circle";
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;
const MAPBOX_TOKEN = 'pk.eyJ1IjoiYmxhbmdlNDgiLCJhIjoiY2xkMWhrcjBzMDB1aDNzbGVsdGR5cGU1aSJ9.xcs1ihAFqlazzqNrXNiobQ';


export default function MapPersonas({
                                        resultsByBvsSynthese,
                                        resultsGeomByBvsSynthese,
                                        resultsGeomIrisByBvsSynthese,
                                        filters,
                                        visible,
                                        resultsByIris,
                                        mappingBvArrondissement
                                    }) {

    const [centroid, setCentroid] = React.useState(null);
    const [bbox, setBBbox] = React.useState(null);

    const [loading, setLoading] = React.useState(true);

    const [bvs, setBvs] = React.useState(null);
    const [filterListOfIris, setFilterListOfIris] = React.useState(false);
    const [filterListOfBv, setFilterListOfBv] = React.useState(false);

    const [popupInfo, setPopupInfo] = React.useState(null);

    const [banPoints, setBanPoints] = React.useState(null);

    React.useEffect(() => {
        if (resultsByIris && mappingBvArrondissement) {
            let bboxShape = {
                "type": "FeatureCollection",
                "features": []
            }
            Object.keys(resultsByIris)
                .filter((id) => {
                    return filters.listOfIris.includes(id)
                })
                .forEach((key, k) => {
                    Object.keys(resultsByIris[key].bvs).forEach((id, k2) => {
                        const correctedId = correctId(id);
                        let finalCorrectedId = correctedId
                        if (resultsByIris[key].bvs[mappingBvArrondissement[correctedId]]) {
                            finalCorrectedId = mappingBvArrondissement[correctedId];
                        }
                        let bvs = resultsByIris[key].bvs[finalCorrectedId];
                        if (bvs) {
                            let color = resultsByIris[key].bvs[finalCorrectedId].color
                            bvs.bans.forEach((ban, index) => {
                                const longitude = Number(ban.latitude)
                                const latitude = Number(ban.longitude)
                                let insert = true;

                                if (insert) {

                                    bboxShape.features.push({
                                        type: "Feature",
                                        geometry: {
                                            type: "Point",
                                            coordinates: [longitude, latitude]
                                        },
                                        properties: {
                                            banId: ban.codeBan,
                                            address: ban.libelleBan,
                                            color: color,
                                            irisId: key,
                                            bvid: finalCorrectedId
                                        }
                                    })
                                }
                            })
                        }
                    })
                })
            setBanPoints(bboxShape);
        }
    }, [resultsByIris])

    React.useEffect(() => {
        if (resultsGeomByBvsSynthese && resultsByBvsSynthese) {
            const flaBvsResults = {}
            Object.keys(resultsByBvsSynthese).forEach((d, k) => {
                Object.keys(resultsByBvsSynthese[d]).forEach((k, i) => {
                    flaBvsResults[k] = resultsByBvsSynthese[d][k];

                })
            })
            let bvs = {}
            Object.keys(resultsGeomByBvsSynthese).forEach((d, k) => {
                let key = resultsGeomByBvsSynthese[d].latitude + "_" + resultsGeomByBvsSynthese[d].longitude;
                if (!bvs[key]) {
                    bvs[key] = {
                        latitude: resultsGeomByBvsSynthese[d].latitude,
                        longitude: resultsGeomByBvsSynthese[d].longitude,
                        id: key,
                        bvs: {}
                    }
                }

                if (filters.listOfBvs.includes(d)) {

                    bvs[key].bvs[d] = {
                        id: d,
                        info: resultsGeomByBvsSynthese[d],
                        results: flaBvsResults[d],
                        color: flaBvsResults[d].color,
                    }
                }
            })
            setBvs(bvs);

        }

    }, [resultsGeomByBvsSynthese, resultsByBvsSynthese]);
    React.useEffect(() => {
        if (resultsGeomIrisByBvsSynthese) {
            let bboxShape = {
                "type": "FeatureCollection",
                "features": []
            };
            Object.keys(resultsGeomIrisByBvsSynthese).forEach((d, k) => {
                let geo = JSON.parse(resultsGeomIrisByBvsSynthese[d].geom);
                bboxShape.features.push({
                    type: "Feature",
                    geometry: geo
                });
            })

            let bbox = turf.bbox(bboxShape);
            let centroid = turf.centroid(bboxShape);
            setCentroid(centroid.geometry.coordinates);
            setBBbox([[bbox[0] - 0.001, bbox[1] - 0.001], [bbox[2] + 0.001, bbox[3] + 0.001]]);
        }

    }, [resultsGeomIrisByBvsSynthese]);

    React.useEffect(() => {
        if (centroid && bbox && resultsByBvsSynthese && resultsGeomByBvsSynthese && resultsGeomIrisByBvsSynthese, bvs) {
            setLoading(false);
        }
    }, [centroid, bbox, resultsByBvsSynthese, resultsGeomByBvsSynthese, resultsGeomIrisByBvsSynthese, bvs])

    if (visible) {
        if (loading) {
            return (<Box sx={{
                width: '100%',
                height: 610,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <CircularProgress/>
            </Box>)
        } else {
            return (<Box sx={{width: '100%', height: 610, display: 'flex', flexDirection: 'row'}}>
                <Box sx={{mr: 2, width: "19%"}}>
                    <Box>
                        <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography>Liste des Bureaux de votes concernés</Typography>
                            <IconButton onClick={() => {
                                setFilterListOfIris(!filterListOfIris)
                            }}>
                                {filterListOfIris && <ArrowDropUpIcon/>}
                                {!filterListOfIris && <ArrowDropDownIcon/>}
                            </IconButton>
                        </Box>
                        {filterListOfIris && <Box>
                            {Object.keys(bvs).map((id, index) => {

                                return Object.keys(bvs[id].bvs).map((idBv, index2) => {
                                    return (<Box sx={{ml: 5}} key={index2}>
                                        <Typography>
                                            <a href={"#" + idBv}>{idBv} {bvs[id].bvs[idBv].info.name}</a></Typography>
                                    </Box>)
                                })
                            })
                            }
                        </Box>}
                    </Box>
                    <Box sx={{mt: 2}}>
                        <Box sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
                            <Typography>Liste des quartiers concernés</Typography>
                            <IconButton onClick={() => {
                                setFilterListOfBv(!filterListOfBv)
                            }}>
                                {filterListOfBv && <ArrowDropUpIcon/>}
                                {!filterListOfBv && <ArrowDropDownIcon/>}
                            </IconButton>
                        </Box>
                        {filterListOfBv && <Box>
                            {filters.listOfIris.map((id, index) => {

                                return (<Box sx={{ml: 5}} key={id}>
                                    <Typography>{id} {correctName(resultsGeomIrisByBvsSynthese[id].irisName)}</Typography>
                                </Box>)
                            })}
                        </Box>}
                    </Box>
                </Box>
                <Map
                    style={{
                        width: "80%",
                        height: 600,
                        borderRadius: 25
                    }}
                    initialViewState={{
                        longitude: centroid[0],
                        latitude: centroid[1],
                        bounds: bbox

                    }}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    mapboxAccessToken={MAPBOX_TOKEN}
                    interactive={true}
                    preserveDrawingBuffer={true}
                    attributionControl={false}
                >
                    {Object.keys(resultsGeomIrisByBvsSynthese).filter((id) => {
                        return filters.listOfIris.includes(id)
                    }).map((id, key) => {
                        const shp = JSON.parse(resultsGeomIrisByBvsSynthese[id].geom);
                        return (<Source
                            key={key}
                            type="geojson"
                            data={shp}>
                            <Layer
                                type={'line'}
                                paint={{
                                    'line-width': 2,
                                    'line-color': '#000000'
                                }}
                            />
                        </Source>)
                    })}
                    {Object.keys(bvs).map((id, key) => {
                        let data = []
                        Object.keys(bvs[id].bvs).forEach((idBv) => {
                            const bv = bvs[id].bvs[idBv];

                            data.push({"title": idBv, "value": 1, "color": bv.color})
                        })
                        let info = {
                            longitude: bvs[id].longitude,
                            latitude: bvs[id].latitude,
                            bvs: bvs[id].bvs
                        }
                        return (<Marker
                            key={`marker-${key}`}
                            longitude={bvs[id].longitude}
                            latitude={bvs[id].latitude}
                            onClick={e => {
                                e.originalEvent.stopPropagation();
                                setPopupInfo(info);
                            }}
                        >
                            <PieChart
                                style={{height: 20, width: 20}}
                                startAngle={-90}
                                data={data}
                            />
                        </Marker>)
                    })}
                    {banPoints &&
                        <Source
                            id="bans"
                            type="geojson"
                            data={banPoints}
                            cluster={false}
                        >
                            <Layer
                                id='bans-point'
                                type='circle'
                                source={"bans"}
                                paint={{
                                    'circle-color': [
                                        'match',
                                        ['get', 'color'],
                                        'winner',
                                        '#0fa64e',
                                        'winnerJuste',
                                        '#86c14d',
                                        'winnerPeu',
                                        '#eeb408',
                                        'winnerLargement',
                                        '#dd110e',
                                        '#ccc'
                                    ],
                                    'circle-radius': 4
                                }}

                            />
                        </Source>}
                    {popupInfo && (
                        <Popup
                            anchor="left"
                            longitude={Number(popupInfo.longitude)}
                            latitude={Number(popupInfo.latitude)}
                            onClose={() => setPopupInfo(null)}


                        >
                            <Box sx={{width: 400, display: "flex", flexDirection: "column"}}>

                                {Object.keys(popupInfo.bvs).map(item => {
                                    let line1 = "";


                                    if (popupInfo.bvs[item].info.info) {
                                        line1 = popupInfo.bvs[item].info.info.libelle_reu;
                                    } else {
                                        line1 = popupInfo.bvs[item].info.name;
                                    }
                                    let winner = popupInfo.bvs[item].results.results[0].winner;

                                    return (<Box key={item} sx={{
                                        display: "flex",
                                        flexDirection: "row",
                                        mb: 2
                                    }}>
                                        <CircleIcon sx={{color: popupInfo.bvs[item].color}}/>
                                        <Box sx={{display: "flex", flexDirection: "column",}}>
                                            <Link href={"#" + item}>
                                                <Typography
                                                    sx={{ml: 1}}>{correctName(line1)}</Typography>
                                            </Link>
                                            <Typography>Abstention: {formatPercentage(popupInfo.bvs[item].results.results[0].abstention.perc)}</Typography>
                                            <Typography>{winner.nomPrenom} ({formatPercentage(winner.perc)})</Typography>
                                        </Box>
                                    </Box>)
                                })}

                            </Box>
                        </Popup>
                    )}

                </Map>

            </Box>);
        }
    }
}
